<template lang="pug">
.doMATERIALANALYSISPROBLEM
  .main-title(:class='{active1:left}')
    .title
      Icon(size='50',color='#FFB419',type="ios-chatbubbles-outline")
      |  {{cont.stem}}
    .tips 下面有{{metas.length}}个问题可以点击提问哦～
    div.main-problem
      li(v-for='(v,index) in metas',@click='Choice(index)',
        :class='{active2:metasState===index}').problem  {{`Q${index+1}：${v.question}`}}
    div.buttom-dt(v-if='left')
      div.type-title  {{JSON.parse(cont.answer).parseQuestion}}
      //- textarea.textarea(placeholder='进行资料分析',v-model='Answer',:disabled='Completed')
      Input(placeholder='进行资料分析' v-model="Answer" maxlength="500" :rows="5" show-word-limit type="textarea" :disabled='Completed').textarea1
      div.bottom
        Button.Sure(@click='Sure',:loading="loading")  确定
  .left-problem(:class='{active:left}',v-if='left')
    .title  {{metas[metasState].question}}
    .content(v-html='metas[metasState].answer')
    div.Questioning(v-if='metas[metasState].extraQuestionsList.length!==0')
      div.tips
         Icon(size='24',color='#FFB419',type="ios-chatbubbles-outline")
         | 可以针对该问题进行追问，注意：只能追问一次哦！
      li(v-for='(v,index) in metas[metasState].extraQuestionsList'
        ,@click='Questioning(index)',
        :class='{active2:QuestioningState[metasState]===index}').Put-questions {{v.question}}
      div.content-title(v-if='QuestioningState.length!==0 && QuestioningState[metasState] !== -1')
        | {{metas[metasState].extraQuestionsList[QuestioningState[metasState]].question}}
      div.content-text(v-if='QuestioningState.length!==0 && QuestioningState[metasState] !== -1',
        v-html='metas[metasState].extraQuestionsList[QuestioningState[metasState]].answer')
</template>
<script>
import bus from "@/utils/main";

export default {
  props: ["cont"],
  data() {
    return {
      step: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      Completed: sessionStorage.getItem("Completed") === "true",
      metas: [],
      Answer: "",
      id: "",
      metasState: -1,
      QuestioningState: [],
      left: false,
      loading: false
    };
  },
  methods: {
    Sure() {
      if (this.Completed) {
        return this.$emit("Determine");
      }
      if (!this.Answer.trim()) {
        return this.$Message.error("请回答问题!");
      }
      console.log(this.$parent);
      const data = [
        {
          caseHallId: this.$store.state.doCase.caseData[
            this.step[+sessionStorage.getItem("doIndex")]
          ].tsId,
          caseStep: this.step[+sessionStorage.getItem("doIndex")],
          classId: sessionStorage.getItem("classId"),
          controlId: this.cont.id,
          id: this.id ? this.id : "",
          controlTypes: this.cont.type,
          experimentId: this.$store.state.doCase.experimentId,
          pyId: this.$store.state.doCase.caseId,
          questionAnswer: this.Answer,
          tsId: this.$parent.cont
            ? this.$parent.cont.tsId
            : this.$store.state.doCase.caseData[
                this.step[+sessionStorage.getItem("doIndex")]
              ].tsId,
          userId: this.$role.code,
          followData: JSON.stringify([this.metasState, this.QuestioningState])
        }
      ];
      this.loading = true;
      this.$http.createStuControl(data).then(res => {
        if (res.data.success) {
          this.$emit("Determine");
        } else {
          this.loading = false;
        }
      }).catch(() => {
          this.loading = false;
      });
    },
    Questioning(index) {
      // 追问
      if (this.QuestioningState[this.metasState] === -1) {
        this.QuestioningState[this.metasState] = index;
      }
      console.log(this.QuestioningState);
      this.$forceUpdate();
    },
    Choice(index) {
      this.metasState = index;
      this.left = true;
      this.$forceUpdate();
    },
    sbChange(value) {
      if (!value) {
        return;
      }
      this.$nextTick(() => {
        this.id = value.id;
        this.Answer = value.questionAnswer;
        const followData = JSON.parse(value.followData);
        if (value.id) {
          this.metasState = followData[0];
          this.QuestioningState = followData[1];
          this.left = true;
        }
      });
    },
    query() {
      const data = {
        id: this.cont.id
      };
      this.$http.getStuControlById(data).then(res => {
        // console.clear();
        console.log(res);
        // if (Array.isArray(this.cont)) {

        // } else {
        //   bus.$emit("onesbChange", res.data.data[this.controList]);
        // }
      });
    }
  },
  beforeDestroy() {
    console.log("onesbChange");
    bus.$off("onesbChange");
  },
  created() {
    bus.$on("onesbChange", this.sbChange);
    console.log(Boolean(this.Completed));
    this.query();
    // this.Answer = value.questionAnswer;
    this.metas = JSON.parse(this.cont.metas);
    this.QuestioningState = new Array(this.metas.length);
    for (let index = 0; index < this.QuestioningState.length; index++) {
      this.QuestioningState[index] = -1;
    }
    console.log("this.metas: ", this.metas);
  }
};
</script>
<style lang="stylus" scoped>
.doMATERIALANALYSISPROBLEM
  height 100%
  width 100%
  .active1
    right auto !important
    transition 1s
    height 588px !important
    left 55% !important
  .main-title
    width 548px
    height 348px
    background rgba(255, 255, 255, 1)
    box-shadow 0px 2px 4px 0px rgba(0, 0, 0, 0.2)
    border-radius 4px
    position absolute
    left 35%
    right 35%
    top 0
    bottom 0
    margin auto
    text-align left
    .buttom-dt
      height 244px
      margin 21px 32px
      .textarea1
        margin-top 5px
      .type-title
        font-size 16px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 1)
        line-height 21px
      .textarea
        width 484px
        height 120px
        background rgba(255, 255, 255, 1)
        border-radius 4px
        border 1px solid rgba(210, 221, 236, 1)
        outline none
        resize none
        padding 5px
      .bottom
        // position absolute
        .Sure
          width 100px
          height 40px
          background rgba(58, 118, 210, 1)
          border-radius 4px
          border none
          outline none
          font-size 14px
          font-family MicrosoftYaHeiUI
          color rgba(255, 255, 255, 1)
          line-height 18px
          position absolute
          right 32px
          bottom 10px
    .title
      overflow auto
      height 120px
      padding 26px 32px
      background #D2DDEC
      box-shadow 0px -1px 0px 0px rgba(210, 221, 236, 1)
      font-size 18px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.8)
      line-height 32px
    .tips
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(128, 128, 128, 1)
      line-height 21px
      margin 24px 36px
    .main-problem
      height 26%
      overflow auto
      border-bottom 1px solid #dddddd
      .problem
        font-size 16px
        margin 0 36px 20px
        cursor pointer
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 0.8)
        line-height 20px
  .left-problem
    padding 38px 48px
    text-align left
    left 0
    top 0
    width 0
    height 100%
    position absolute
    background rgba(255, 255, 255, 1)
    box-shadow 1px 0px 2px 0px rgba(0, 0, 0, 0.2)
    overflow auto
    .title
      font-size 16px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color rgba(42, 46, 54, 0.8)
      line-height 20px
    .content
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.75)
      line-height 24px
      margin-top 30px
      padding-bottom 30px
      border-bottom 1px solid #dddddd
    .Questioning
      margin-top 35px
      .tips
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(222, 146, 20, 1)
        line-height 18px
        margin-bottom 20px
      .Put-questions
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 0.8)
        line-height 18px
        padding 5px
        cursor pointer
      .content-title
        font-size 16px
        font-family MicrosoftYaHeiUI-Bold
        font-weight bold
        color rgba(58, 118, 210, 1)
        line-height 20px
        margin-top 30px
      .content-text
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 0.75)
        line-height 24px
        margin-top 18px
  .active
    width 50%
    transition 2s
  .active2
    background #3885E1
    padding 6px 0 6px
    color #ffffff !important
</style>
